"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function DropZoneComponent({ label, types, onChange, accept, disabled }) {
    const handleDrop = (event) => {
        event.preventDefault();
        if (disabled)
            return;
        const droppedFile = event.dataTransfer.files[0];
        if (droppedFile) {
            onChange(droppedFile);
            event.target.value = null;
        }
    };
    const handleDragOver = (event) => {
        if (disabled)
            return;
        event.preventDefault();
    };
    const randomNum = Math.floor(Math.random() * 10000);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { onDrop: handleDrop, onDragOver: handleDragOver, className: `flex items-center justify-center w-full ${disabled ? "opacity-50 cursor-not-allowed" : ""}` },
            react_1.default.createElement("label", { htmlFor: `dropzone-file-${randomNum}`, className: `flex flex-col items-center justify-center w-full h-64 border-2 border-borders border-dashed rounded-lg bg-white hover:border-superDark ${disabled ? "pointer-events-none" : "cursor-pointer"}` },
                react_1.default.createElement("div", { className: "flex flex-col items-center justify-center pt-5 pb-6" },
                    react_1.default.createElement("svg", { className: "w-8 h-8 mb-4 text-superDark dark:text-superDark", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 16" },
                        react_1.default.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" })),
                    react_1.default.createElement("p", { className: "mb-2 text-sm text-superDark dark:text-superDark" }, label),
                    react_1.default.createElement("p", { className: "text-xs text-superDark " },
                        " ",
                        types)),
                react_1.default.createElement("input", { id: `dropzone-file-${randomNum}`, type: "file", className: "hidden", accept: accept !== null && accept !== void 0 ? accept : "", disabled: disabled, onChange: (e) => {
                        if (disabled)
                            return;
                        onChange(e.target.files[0]);
                        e.target.value = null;
                    } })))));
}
exports.default = DropZoneComponent;
